import React from 'react';

import { useTranslation } from 'react-i18next';

import Footer from 'Components/Footer';
import Header from 'Components/Header';
import WorkerJobList from 'Components/WorkerJobList';

export default function Jobs() {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <WorkerJobList
        showSearch={true}
        headerTitle={t('jobs.title')}
        headerDescription={t('jobs.description')}
        bg='bg'
        overlay='dark'
      />
      <Footer />
    </>
  );
}